"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { signIn } from "next-auth/react";
import { useRouter } from "next/navigation";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
const loginSchema = z.object({
  username: z.string().min(1, "Username is required"),
  password: z.string().min(1, "Password is required")
});
export function LoginForm() {
  const $ = _c(24);
  const router = useRouter();
  const [error, setError] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      resolver: zodResolver(loginSchema),
      defaultValues: {
        username: "",
        password: ""
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const form = useForm(t0);
  let t1;
  if ($[1] !== router) {
    t1 = async function onSubmit(values) {
      setError(null);
      const result = await signIn("credentials", {
        username: values.username,
        password: values.password,
        redirect: false
      });
      if (result?.error) {
        setError("Invalid username or password");
      } else {
        router.push("/");
        router.refresh();
      }
    };
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onSubmit = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CardHeader><CardTitle>GSJ ERP Login</CardTitle></CardHeader>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== form || $[5] !== onSubmit) {
    t3 = form.handleSubmit(onSubmit);
    $[4] = form;
    $[5] = onSubmit;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  let t5;
  if ($[7] !== form.control) {
    t4 = <FormField control={form.control} name="username" render={_temp} />;
    t5 = <FormField control={form.control} name="password" render={_temp2} />;
    $[7] = form.control;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] !== error) {
    t6 = error && <p className="text-sm text-red-500">{error}</p>;
    $[10] = error;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = form.formState.isSubmitting ? "Logging in..." : "Login";
  let t8;
  if ($[12] !== form.formState.isSubmitting || $[13] !== t7) {
    t8 = <Button type="submit" className="w-full" disabled={form.formState.isSubmitting}>{t7}</Button>;
    $[12] = form.formState.isSubmitting;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6 || $[19] !== t8) {
    t9 = <form onSubmit={t3} className="space-y-4">{t4}{t5}{t6}{t8}</form>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== form || $[22] !== t9) {
    t10 = <Card className="w-[350px]">{t2}<CardContent><Form {...form}>{t9}</Form></CardContent></Card>;
    $[21] = form;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
function _temp2(t0) {
  const {
    field: field_0
  } = t0;
  return <FormItem><FormLabel>Password</FormLabel><FormControl><Input type="password" {...field_0} /></FormControl><FormMessage /></FormItem>;
}
function _temp(t0) {
  const {
    field
  } = t0;
  return <FormItem><FormLabel>Username</FormLabel><FormControl><Input {...field} /></FormControl><FormMessage /></FormItem>;
}